import { ID } from '@/data/types/Basic';

export const DO_NOT_UPDATE_ESPOT: ID[] = [
	'MainHeader_SuperiorSection',
	'MainHeader_InferiorSection',
	'MobileMenu_Departments_SuperiorSection',
	'Menu_inferiorSection',
	'Menu_inferiorSection1',
	'Menu_inferiorSection2',
	'Menu_inferiorSection3',
	'Menu_inferiorSection4',
	'Menu_inferiorSection5',
	'MainFooter_SuperiorSection',
	'MainFooter_InferiorSection',
	'MainFooter_Navigation1',
	'MainFooter_Navigation2',
	'MainFooter_Navigation3',
	'MainFooter_Navigation4',
	'MainHeader_Logo',
	'Menu_dynamicTrigger_1',
	'Menu_dynamicTrigger_2',
	'Menu_dynamicTitle_1',
	'Menu_dynamicTitle_2',
	'Menu_dynamicItems_1',
	'Menu_dynamicItems_2',
];
export const HEADER_ESPOT_SUPERIOR_SECTION = 'MainHeader_SuperiorSection';

export const HEADER_ESPOT_LOWER_SECTION = 'MainHeader_InferiorSection';
export const HEADER_ESPOT_MENU_TRIGGER_1 = 'Menu_dynamicTrigger_1';
export const HEADER_ESPOT_MENU_TRIGGER_2 = 'Menu_dynamicTrigger_2';
export const HEADER_ESPOT_MENU_ITEMS_1 = 'Menu_dynamicItems_1';
export const HEADER_ESPOT_MENU_ITEMS_2 = 'Menu_dynamicItems_2';
export const HEADER_ESPOT_MENU_TITLE_1 = 'Menu_dynamicTitle_1';
export const HEADER_ESPOT_MENU_TITLE_2 = 'Menu_dynamicTitle_2';
export const HEADER_SEARCH_SUGGESTION_INF_SECTION = 'searchSuggest_InferiorSection';
export const HEADER_SEARCH_SUGGESTION_POPULAR_CART = 'searchSuggest_PopularCat';
export const ESPOT_MENUS = [
	{
		trigger: HEADER_ESPOT_MENU_TRIGGER_1,
		title: HEADER_ESPOT_MENU_TITLE_1,
		items: HEADER_ESPOT_MENU_ITEMS_1,
	},
	{
		trigger: HEADER_ESPOT_MENU_TRIGGER_2,
		title: HEADER_ESPOT_MENU_TITLE_2,
		items: HEADER_ESPOT_MENU_ITEMS_2,
	},
];
export const CATALOG_PREFIX = '/b';
export const HEADER_DEPARTMENT_LABEL = 'Departamentos';
export const PRO_PATH = 'pro';

export const MAIN_HEADER_LOGO_ESPOT = 'MainHeader_Logo';
export const BASE_ROUTE_HOME = '/';

export const HEADER_ID = 'hdm-header';
export const HEADER_ADOBE_TARGET_VIEW = 'header';
export const BOTTOM_NAVIGATION_ID = 'hdm-bottom-navigation';
export const BOTTOM_NAVIGATION_Z_INDEX = 1201;
export const PDP_STICKY_COMPONENT_Z_INDEX = 1199;

export const RECENT_SEARCH_KEY = 'recent-search';
export const RECENT_PRODUCT_KEY = 'recent-product';

export enum OPTION_TYPES {
	Brand = 'Brand',
	Keyword = 'Keyword',
	Category = 'Category',
	RecentSearch = 'RecentSearch',
	RecentProduct = 'RecentProduct',
}
